function configMaterial($provide: angular.auto.IProvideService) {
    /**
     * Override angular-material's sanitizeRegex function so that it
     * treats each word as its own term instead of the whole string as a single term,
     * this enables the search box to highlight all words even if they are not in sequential order on one property
     */

    $provide.decorator('mdHighlightTextDirective', ['$delegate', '$controller', function ($delegate: any, $controller: any) {
        const directive = $delegate[0];
        let controllerName = directive.controller;

        directive.controller = ['$scope', '$element', '$attrs', function ($scope, $element, $attrs) {
            let controller = $controller(controllerName, { $scope: $scope, $element: $element, $attrs: $attrs });

            let originalSanitizeRegex = controller.sanitizeRegex;

            controller.sanitizeRegex = (term: string = '') => {
                return originalSanitizeRegex(term).replace(/\s+/g, '|');
            };

            return controller;
        }];

        return $delegate;
    }]);

    /** Enable $mdPanels to be closed by tapping outside of them when the 'clickOutsideToClose' option is passed in */
    $provide.decorator('$mdPanel', ['$delegate', function ($delegate: any) {
        let originalCreate = $delegate.create;

        let newCreate = (config: any) => {
            let panelRef = originalCreate.call($delegate, config);

            let _configureTapOutsideToClose = function () {
                /* This is simply the original code for _configureClickOutsideToClose with the event names changed */
                if (this.config['clickOutsideToClose']) {
                    var target = this.panelContainer;
                    var sourceElem;

                    // Keep track of the element on which the mouse originally went down
                    // so that we can only close the backdrop when the 'click' started on it.
                    // A simple 'click' handler does not work,
                    // it sets the target object as the element the mouse went down on.
                    var mousedownHandler = function (ev) {
                        sourceElem = ev.target;
                    };

                    // We check if our original element and the target is the backdrop
                    // because if the original was the backdrop and the target was inside the
                    // panel we don't want to panel to close.
                    // tslint:disable-next-line: no-this-assignment
                    var self = this;
                    var mouseupHandler = function (ev) {
                        if (sourceElem === target[0] && ev.target === target[0]) {
                            ev.stopPropagation();
                            ev.preventDefault();

                            self.close();
                        }
                    };

                    // Add listeners
                    target.on('touchstart', mousedownHandler);
                    target.on('touchend', mouseupHandler);

                    // Queue remove listeners function
                    this._removeListeners.push(function () {
                        target.off('touchstart', mousedownHandler);
                        target.off('touchend', mouseupHandler);
                    });
                }
            };

            let originalAddEventListeners = panelRef._addEventListeners;

            panelRef._addEventListeners = function () {
                originalAddEventListeners.call(panelRef);
                _configureTapOutsideToClose.call(panelRef);
            };

            return panelRef;
        };

        $delegate.create = newCreate;

        return $delegate;
    }]);

    /**
     * This decorator is a workaround for the issue where an overflowed md-select would require two taps to activate a selection on an iPad
     * CASLink-2769
     */
    $provide.decorator('$mdSelect', ['$delegate', function ($delegate: any) {
        let originalShow = $delegate.show;

        $delegate.show = (opts) => {
            opts.onComplete = () => {
                opts.element.find('md-content').scrollTop(1);
            };

            return originalShow(opts);
        };

        return $delegate;
    }]);

    /**
     * Makes dialog closings have a message that can be safely ignored by the globalExceptionHandler
     * Since this throws, catch blocks at a lower level should still run, and then blocks should not
     * See $exceptionHandler factory
     */
    $provide.decorator('$mdDialog', ['$delegate', function ($delegate: any) {
        let original = $delegate.show;

        // tslint:disable-next-line: max-line-length
        $delegate.show = (dialog: angular.material.IDialogOptions | angular.material.IAlertDialog | angular.material.IConfirmDialog | angular.material.IPromptDialog) => {
            if ((dialog as any).skipHide) {
                throw new Error(`skipHide is deprecated but has not been removed from @types/angular-material as of writing
                                -- please use "multiple" instead`);
            }

            return original(dialog).catch(() => { throw new Error('ignore'); });
        };

        return $delegate;
    }]);
}

export default configMaterial;
